<template>
  <div class="wechat-menu">
    <el-row :gutter="20">
      <el-col :span="6">
        <span style="font-size: 14px">预览界面</span>
        <div class="border">
          <ul class="first-menu">
            <li
                v-for="item in menuList"
                :key="item.id"
                :class="selectedMenu.id == item.id ? 'selected':''"
                @click.stop="selectFirstMenu(item)">{{item.name}}
              <ul class="second-memu" v-show="selectId == item.id">
                <li class="add-second-menu" @click.stop="addSecondMenu" v-show="menuList.filter(menu => menu.id == selectId)[0].children.length < 5">
                  <img src="../assets/weibiaoti1.png" style="width: 30px;margin-top: 4px">
                </li>
                <li
                  v-for="child in item.children"
                  :key="child.id"
                  :class="selectedMenu.id == child.id ? 'selected':''"
                  @click.stop="selectSecondMenu(child)">
                  {{child.name}}
                </li>
              </ul>
            </li>
            <li v-if="menuList.length < 3" @click.stop="addFirstMenu" class="add-first-menu">
              <img src="../assets/weibiaoti1.png" style="width: 30px;margin-top: 4px">
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="16">
        <span style="font-size: 14px">菜单设置</span>
        <div class="border menusetting">
          <div v-if="menuList.length > 0 && selectedMenu">
            <div class="title">
              <span>{{selectedMenu.name}}</span>
              <el-button  type="text" style="float: right" @click="deleteMenu">删除菜单</el-button>
            </div>
            <div style="margin:20px;height: 380px;overflow: auto">
              <el-form label-width="80px" style="width: 60%">
                <el-form-item label="菜单名称">
                  <el-input v-model="selectedMenu.name"></el-input>
                  <span style="color: #999">仅支持中英文和数字，字数不超过4个汉字或8个字母</span>
                  <br>
                  <span v-show="selectedMenu.children != null && selectedMenu.children != 0" style="color: #999">
                    该菜单有子菜单，只能设置菜单名称
                  </span>
                </el-form-item>
                <el-form-item label="菜单内容" v-show="selectedMenu.children == null || selectedMenu.children == 0">
                  <el-radio v-model="selectedMenu.type" label="1">发送消息</el-radio>
                  <el-radio v-model="selectedMenu.type" label="2">跳转网页</el-radio>
                  <el-radio v-model="selectedMenu.type" label="3" disabled>跳转小程序</el-radio>
                  <div><span style="color: #999;line-height: 20px">跳转小程序暂未开启</span></div>
                </el-form-item>
                <div style="border:solid 1px #dcdcdc;background-color: #ffffff;padding:0 20px;"
                     v-show="selectedMenu.type == '2' && (selectedMenu.children == null || selectedMenu.children == 0)">
                  <span style="color: #999;font-size: 14px;line-height: 40px">订阅者点击该子菜单会跳到以下链接</span>
                  <el-form-item label="页面地址">
                    <el-input type="textarea"
                              :rows="4"
                              v-model="selectedMenu.url">
                    </el-input>
                    <el-button  type="text" @click="selectChannel">选择频道</el-button>
                  </el-form-item>
                </div>
              </el-form>
              <div  v-show="selectedMenu.type == '2' && (selectedMenu.children == null || selectedMenu.children == 0)">
                <p>url示例：（请严格按照示例填写）</p>
                <span>https://open.weixin.qq.com/connect/oauth2/authorize?
                  appid=公众号appid&redirect_uri=http://www.mumetech.com/cardRecycle?
                companyId=单位Id&response_type=code&scope=snsapi_base,snsapi_userinfo&state=STATE
                &component_appid=wxf9d1bf704b0ecaaf#wechat_redirect</span>
              </div>
              <el-tabs type="border-card" style="width: 60%"
                       v-show="selectedMenu.type == '1' && (selectedMenu.children == null || selectedMenu.children == 0)">
                <el-tab-pane label="文字">
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="selectedMenu.text">
                  </el-input>
                </el-tab-pane>
                <el-tab-pane label="图片" style="text-align: center" disabled>
                  <el-button  type="text">选择素材</el-button>
                </el-tab-pane>
                <el-tab-pane label="图文消息" disabled>
                  <div class="tab-content" style="text-align: center">
                    <el-button  type="text">选择素材</el-button>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="语音" disabled>语音</el-tab-pane>
                <el-tab-pane label="视频" disabled>视频</el-tab-pane>
              </el-tabs>
            </div>
            <div style="height: 40px;padding-right:20px">
              <el-button type="primary" size="small" style="float: right" @click="submit">保存并发布</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="选择频道"
      :visible.sync="dialogVisible"
      width="40%">
      <el-radio v-for="item in channelList" :key="item.id" v-model="selectChannelUrl" :label="item.url">{{item.name}}</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectChannelSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../utils/utils'
  export default {
    name: "wechat-menu",
    data(){
      return{
        dialogVisible:false,
        menuList:[],
        index:0,
        selectId:null,
        selectedMenu:{
          id:"",
          name:"",
          type:"",
          text:"",
          url:"",
          children:[]
        },
        selectChannelUrl:"",
        channelList:[]
      }
    },
    created(){
      this.getMenu()
    },
    methods:{
      getMenu(){
        utils.axiosMethods({
          method:"GET",
          url:"api/wechat/queryWechatMenu",
          callback:(res => {
            if(res.data.code == 0){
              this.menuList = res.data.list
              if(this.menuList.length > 0){
                this.selectedMenu = this.menuList[0]
                this.selectId = this.selectedMenu.id
              }
            }
          })
        })
      },
      addFirstMenu(){
        let date = new Date();
        let menu = {
          id:"firstMenu-"+date.getTime()+this.index,
          name:"菜单名称",
          type:"1",
          text:"",
          url:"",
          children:[]
        };
        this.menuList.push(menu);
        this.selectId = "firstMenu-"+date.getTime()+this.index
        this.selectedMenu = menu
        this.index ++
      },
      addSecondMenu(){
        let menu = {
          id:"secondMenu-"+this.index,
          name:"菜单名称",
          type:"1",
          text:"",
          url:"",
        };
        this.menuList.map(item => {
          if(item.id == this.selectId){
            if(item.children.length > 0){
              item.children.unshift(menu)
            }else{
              item.children.push(menu)
            }

          }
        })
        this.selectedMenu = menu
        this.index ++
      },
      selectFirstMenu(menu){
        this.selectedMenu = menu
        this.selectId = menu.id
      },
      selectSecondMenu(menu){
        this.selectedMenu = menu
      },
      deleteMenu(){
        if(this.selectedMenu.children && this.selectedMenu.children.length > 0){
          this.$message.error("该菜单有子菜单，请先删除子菜单")
          return;
        }
        this.menuList = this.menuList.filter(item => item.id != this.selectedMenu.id)
        this.menuList.map(item => {
          if(item.children.length > 0){
            item.children = item.children.filter(child => child.id != this.selectedMenu.id)
          }
        })
        this.selectedMenu = this.menuList.length > 0 ? this.menuList[0] :{
          id:"",
          name:"",
          type:"",
          text:"",
          url:"",
          children:[]
        }
      },
      submit(){
        utils.axiosMethods({
          method:"POST",
          url:"api/wechat/ceateWechatMenu",
          data:{
            menu:JSON.stringify(this.menuList)
          },
          callback:(res => {
            if(res.data.code == 0){
              this.$message.success("保存成功")
            }else{
              this.$message.error(res.data.msg)
            }
          })
        })
      },
      selectChannel(){
        utils.axiosMethods({
          method:"GET",
          url:"api/shop/getChannelUrl",
          callback:(res => {
            if(res.data.code == 0){
              this.dialogVisible = true
              this.channelList = res.data.list;
            }else{
              this.$message.error(res.data.msg)
            }
          })
        })
      },
      selectChannelSure(){
        this.selectedMenu.url = this.selectChannelUrl
        this.dialogVisible = false
      }
    }
  }
</script>

<style scoped lang="less">
.wechat-menu{
  .border{
    height: 500px;
    border:solid 1px #dcdcdc;
    width: 100%;
    position: relative;
    .first-menu{
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      background-color: #ececec;
      padding:0;
      margin: 0;
      text-align: center;
      border-top:solid 1px #dcdcdc;
      width: 100%;
      >li:last-child{
        border-right: 0;
      }
      .add-first-menu{
        line-height:unset;
      }
      >li{
        flex: 1;
        list-style: none;
        border-right: solid 1px #dcdcdc;
        position: relative;
        line-height: 40px;
        .second-memu{
          position:absolute;
          bottom: 40px;
          left: 0;
          padding:0;
          margin: 0;
          width: 100%;
          background-color:  #ececec;
          >li{
            display: block;
            border-right: solid 1px #dcdcdc;
            border-bottom: solid 1px #dcdcdc;
            line-height: 40px;
            height: 40px;
            color: #2c3e50;
          }
          >li[class~=selected]{
            line-height: 38px;
            border:solid 1px #5daf34 !important;
            color: #5daf34 !important;
          }
          .add-second-menu{
            line-height:unset;
          }
        }
      }
      >li[class~=selected]{
        line-height: 38px;
        border:solid 1px #5daf34 !important;
        color: #5daf34;
      }
      li:hover{
        cursor: pointer;
      }

    }
  }
  .menusetting{
    .title{
      margin:0 20px;
      line-height: 40px;
      border-bottom: solid 1px #dcdcdc;
    }
    .tab-content{
      height: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wechatMenu.vue